import styled from 'styled-components';
import { zIndex } from 'utils';
import { fadeIn } from 'utils/keyframes';

export const Wrapper = styled.aside`
  background: transparent;
  width: 100%;
  animation: 2s ${fadeIn} ease-out;
  position: relative;
`;

export const Overlay = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  display: none;
  transition: 0.4s;

  ${({ sidebar }) =>
    sidebar &&
    `
			display: block;
			z-index: ${zIndex.level4};	
	`}
`;
